export enum FeedTypes {
	FAVOURITE_TEAM = 'favourite_team',
	FOLLOWED_TEAMS = 'followed_teams',
	PARTNER_FEED = 'partner_feed',
	SOCIAL_FEED = 'news_feed',
	SUGGESTED_FEED = 'suggested_feed',
	USER_FEED = 'user_feed'
}
